<div class="page-wrapper">

  <!-- Error -->
  <div *ngIf="error" class="error-card">
    <h2>Error</h2>
    <p>{{ error }}</p>
  </div>

  <!-- Loading -->
  <div *ngIf="loading && !event" class="text-center">
    <p>Loading event information...</p>
  </div>

  <!-- Thank You Content -->
  <div *ngIf="event && !loading" class="thank-you-card">
    <div class="success-icon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
      </svg>
    </div>

    <h1 class="thank-you-title">Thank You for Registering!</h1>

    <p class="thank-you-message">
      You have been registered for the following program.
    </p>

    <div class="event-summary">
      <!-- Program Title -->
      <div class="summary-row" *ngIf="event.topic">
        <span class="summary-label">Program Title</span>
        <span class="summary-value">{{ event.topic }}</span>
      </div>

      <!-- Speaker(s) -->
      <div class="summary-row" *ngIf="event.speakers?.length">
        <span class="summary-label">{{ event.speakers!.length === 1 ? 'Speaker' : 'Speakers' }}</span>
        <span class="summary-value">
          <ng-container *ngFor="let speaker of event.speakers; let last = last">
            {{ speaker.fullName }}{{ speaker.degrees ? ', ' + speaker.degrees : '' }}{{ last ? '' : ' · ' }}
          </ng-container>
        </span>
      </div>

      <!-- Date -->
      <div class="summary-row" *ngIf="event.friendlyDate">
        <span class="summary-label">Date</span>
        <span class="summary-value">{{ event.friendlyDate }}</span>
      </div>

      <!-- Time -->
      <div class="summary-row" *ngIf="event.startTime">
        <span class="summary-label">Time</span>
        <span class="summary-value">{{ event.startTime }} {{ formatTimezone() }}</span>
      </div>

      <!-- Location -->
      <div class="summary-row" *ngIf="event.venue">
        <span class="summary-label">Location</span>
        <span class="summary-value">{{ event.venue.name }}</span>
      </div>

      <!-- Meeting Type -->
      <div class="summary-row" *ngIf="event.meetingType">
        <span class="summary-label">Meeting Type</span>
        <span class="summary-value">{{ event.meetingType }}</span>
      </div>
    </div>

    <p class="confirmation-note">
      An email confirming your registration will be sent to the email address you provided.
    </p>
  </div>

</div>
